import axios from 'axios';

import { AUX_TRANSLATIONS, AUX_VALUE, AUX_VALUE_GROUP } from '../endpoints';

export interface AuxTranslation {
  name: string;
  languageCode: string;
}

export interface AuxValueGroup {
  auxValueGroupId: number;
  code: string;
  name: string;
}

export interface AuxValue {
  auxValueId: number;
  code: string;
  sortOrder: string;
  auxValueGroupId: number;
  auxValueGroupName: string;
  translations: AuxTranslation[];
  colorCode: `#${string}` | undefined;
  flags: string[];
}

export interface AuxTranslationEntity extends AuxTranslation {
  auxValueTranslationId?: number | null;
  auxValueId?: number | null;
}

export const getAuxValues = () => axios.get<AuxValue[]>(AUX_VALUE);

export const getAuxValueGroups = () =>
  axios.get<AuxValueGroup[]>(AUX_VALUE_GROUP);

export const getAuxValueById = (id?: number) =>
  axios.get<AuxValue>(`${AUX_VALUE}/${id}`);

export const getAuxValueTranslationsByAuxValueId = (auxValueId: number) =>
  axios.get<AuxTranslationEntity[]>(
    `${AUX_TRANSLATIONS}?auxValueId=${auxValueId}`
  );

export const createAuxValueTranslation = (data) =>
  axios.post<AuxTranslationEntity>(AUX_TRANSLATIONS, data);

export const editAuxValueTranslation = (data) =>
  axios.put(`${AUX_TRANSLATIONS}/${data.auxValueTranslationId}`, data);
